import React from "react";
import styles from "./logoutModal.module.scss";

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true">
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.iconWrapper}>
          <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.79167 41.125C8.71458 41.125 7.79253 40.7415 7.02552 39.9745C6.25851 39.2075 5.875 38.2854 5.875 37.2083V9.79167C5.875 8.71458 6.25851 7.79253 7.02552 7.02552C7.79253 6.25851 8.71458 5.875 9.79167 5.875H23.5V9.79167H9.79167V37.2083H23.5V41.125H9.79167ZM31.3333 33.2917L28.6406 30.4521L33.6344 25.4583H17.625V21.5417H33.6344L28.6406 16.5479L31.3333 13.7083L41.125 23.5L31.3333 33.2917Z" fill="#F34C4F"/>
          </svg>
        </div>

        <h2 className={styles.title}>Do you want to log out?</h2>
        <p className={styles.subtitle}>
          You will need to sign in again to access your account services.
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.noButton}
            onClick={onClose}
          >
            No
          </button>
          <button
            type="button"
            className={styles.yesButton}
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
